<template>
  <div>
    <div>Scaffold:</div>
    <ProteinLoader example-act="scaffold-edit" role="scaffold" />
    <div>Insert:</div>
    <ProteinLoader role="insert" />
  </div>
</template>

<script>
import ProteinLoader from "./ProteinSelection/ProteinLoader";
export default {
  components: {
    ProteinLoader,
  },
};
</script>

<style scoped>
</style>